import React from 'react';

interface Props {
  label: string,
  isSelected?: boolean
  onClickFunction: () => void;
}

const PicklistButton: React.FC<Props> = ({ label, isSelected, onClickFunction }) => {
  return (
    <button onClick={onClickFunction} className="z-20 relative flex justify-start pl-4 items-center text-cents-black bg-cents-white h-10 w-full rounded-2xl text-sm">
      <div className={`${isSelected ? "selected" : ""} break-words`}>
        {label}
      </div>
    </button>
  );
};

export default PicklistButton;